'use client';

import { createContext, useContext, useState } from 'react';

import { pushGAEvent } from '@widget/analytics';

import type { FC, PropsWithChildren } from 'react';

export type GAEventContext = {
  increaseCtaVisible?: () => void;
};

const GAEventContext = createContext<GAEventContext>({});

const SendGAEvent: React.FC = () => {
  pushGAEvent('custom-event', { stepName: 'x_impression' });
  return <></>;
};

export const GAEventProvider: FC<PropsWithChildren> = ({ children }) => {
  const [ctaVisible, setCtaVisible] = useState(0);

  const increaseCtaVisible = (): void => {
    setCtaVisible((currentState) => currentState + 1);
  };

  return (
    <GAEventContext.Provider value={{ increaseCtaVisible }}>
      {children}
      {ctaVisible >= 1 && <SendGAEvent />}
    </GAEventContext.Provider>
  );
};

export const useCtaVisible = (): GAEventContext => {
  const context = useContext(GAEventContext);

  return context;
};
